/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { getItemContentAndValue } from '../../fc-form-field-helper';

/**
 * Render: RadioGroup
 * @return {*}
 */
export const render_radio_group = function() {
  const { options, value, disabled } = this;
  const slottedOptions = Array.from(this.querySelectorAll('option'));
  const isSlottedOptions = slottedOptions.length;
  const selectOptions = (isSlottedOptions ? slottedOptions : options) || [];
  return html`
      <fc-radio-group
        .checked="${value}"
        ?disabled=${disabled}
        @select="${e => this.setValue(e.detail.value)}">
             ${selectOptions.map(select => {
    const { itemValue, itemContent } = getItemContentAndValue(select);
    return html`<fc-radio
                              ?disabled="${disabled}"
                              ?checked="${itemValue === value}"
                              .value="${itemValue}">
                              ${unsafeHTML(itemContent)}
                            </fc-radio>`;
  })}
      </fc-radio-group>`;
};
